module.exports = __webpack_public_path__ + "static/media/venetian05.4ddc2def.png";